export const environment = {

  // xenovex dev
  //imageBaseUrl: 'https://kcbtimages.xenovex.com/Attachment/',
  //apiBaseUrl: 'https://devkcbtapi.xenovex.com',

  // xenovex Live
   imageBaseUrl: 'https://kcbtimages.xenovex.com/Attachment/',
    apiBaseUrl: 'https://kcbtapi.xenovex.com',


//local 
//apiBaseUrl: 'http://localhost:5005',

  // Tn servcer live
  // imageBaseUrl: 'https://kcbtcmda.tn.gov.in/images/Attachment/',
  // apiBaseUrl: 'https://kcbtcmda.tn.gov.in/api',

  tokenEndPoint: "/api/token",
  production: false,
  environment: "Local",
  showEnvironment: true,
};
